module.exports = __webpack_public_path__ + "static/media/g2-review-cup.b02bdae5.png";